// extracted by mini-css-extract-plugin
export default {"search":"Search_search__lVNFu","search__input":"Search_search__input__36Wmk","icon_search":"Search_icon_search__1XkS4"};